module.exports = __webpack_public_path__ + "img/map_toilet_5.eeb565ec.png";